import app from 'flarum/forum/app';
let cache = null;
let loadedAt = 0;
let pending = null;

/** Данные для главной (статистика, онлайн, популярное). Кэш на 60 секунд. */
export function overview() {
  return cache;
}
export function loadOverview(force = false) {
  if (!force && cache && Date.now() - loadedAt < 60000) return Promise.resolve(cache);
  if (pending) return pending;
  pending = app.request({
    method: 'GET',
    url: app.forum.attribute('apiUrl') + '/sublace/overview'
  }).then(data => {
    cache = data;
    loadedAt = Date.now();
    return data;
  }).catch(() => cache).finally(() => {
    pending = null;
    m.redraw();
  });
  return pending;
}
flarum.reg.add('sublace-forum', 'forum/states/overview', { overview: overview,loadOverview: loadOverview, });